import UpdateFeedPage from "./update-feed.page";

export default UpdateFeedPage;
